import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertCircle, Upload, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-banking`;

const readFile = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = reject;
  r.readAsDataURL(file);
});

export const CollateralDocsReminder = ({ pending, token, onUploaded }) => {
  const [busy, setBusy] = useState(null);
  if (!pending?.length) return null;

  const upload = async (kind, file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('File must be under 5 MB'); return; }
    setBusy(kind);
    try {
      const r = await axios.post(`${API}/credit-line/collateral-docs`, { [`${kind}_base64`]: await readFile(file) },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(r.data.message); onUploaded?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Upload failed'); }
    finally { setBusy(null); }
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/40 rounded-xl p-5" data-testid="collateral-docs-reminder">
      <p className="text-amber-200 font-semibold flex items-center gap-2"><AlertCircle className="w-5 h-5" /> Collateral documents pending</p>
      <p className="text-sm text-amber-300/90 mt-1">Your account is fully active. Please upload the remaining collateral documents pledged under your Subscriber Credit Agreement when you can.</p>
      <div className="flex flex-wrap gap-3 mt-4">
        {pending.map(d => (
          <label key={d.kind} data-testid={`collateral-upload-${d.kind}`}
            className="cursor-pointer px-4 py-2 border border-amber-400 text-amber-100 hover:bg-amber-500/10 rounded-lg text-sm flex items-center gap-2">
            {busy === d.kind ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload {d.label}
            <input type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" disabled={!!busy}
              data-testid={`collateral-upload-input-${d.kind}`} onChange={(e) => upload(d.kind, e.target.files[0])} />
          </label>
        ))}
      </div>
    </div>
  );
};
